import { render, staticRenderFns } from "./FilterBar.vue?vue&type=template&id=608c1479&lang=pug"
import script from "./FilterBar.vue?vue&type=script&lang=js"
export * from "./FilterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports